import {Brand} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/brand.types';
import {Product} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/product.types';
import {DeliveryWishlistButton} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';
import {WishlistButton as WishlistButtonBase} from '../../../../features/Wishlist/WishlistButton';

export const WishlistButton: React.FC<{
  brand: Brand;
  product: Product;
  trackingData?: {
    sortingChannel?: string;
  };
}> = ({brand, product, trackingData}) => {
  return (
    <Wrapper>
      <WishlistButtonBase
        product={product}
        brand={brand}
        WishlistComponent={DeliveryWishlistButton}
        trackingData={trackingData}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
`;
